module.exports = __webpack_public_path__ + "img/ysgj_003@2x.876b3c22.png";